import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconBadge: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 21.75H7C4.582 21.75 3.25 20.418 3.25 18V6C3.25 3.582 4.582 2.25 7 2.25H17C19.418 2.25 20.75 3.582 20.75 6V18C20.75 20.418 19.418 21.75 17 21.75ZM7 3.75C5.423 3.75 4.75 4.423 4.75 6V18C4.75 19.577 5.423 20.25 7 20.25H17C18.577 20.25 19.25 19.577 19.25 18V6C19.25 4.423 18.577 3.75 17 3.75H7ZM14.25 6C14.25 5.586 13.914 5.25 13.5 5.25H10.5C10.086 5.25 9.75 5.586 9.75 6C9.75 6.414 10.086 6.75 10.5 6.75H13.5C13.914 6.75 14.25 6.414 14.25 6ZM12.005 13.55C10.682 13.55 9.60498 12.473 9.60498 11.15C9.60498 9.82702 10.682 8.75 12.005 8.75C13.328 8.75 14.405 9.82702 14.405 11.15C14.405 12.473 13.328 13.55 12.005 13.55ZM12.005 10.25C11.509 10.25 11.105 10.654 11.105 11.15C11.105 11.646 11.509 12.05 12.005 12.05C12.501 12.05 12.905 11.646 12.905 11.15C12.905 10.654 12.501 10.25 12.005 10.25ZM14.999 18.25C14.585 18.25 14.249 17.914 14.249 17.5V17.197C14.249 16.477 13.752 15.75 12.641 15.75H11.357C10.246 15.75 9.74902 16.477 9.74902 17.197V17.5C9.74902 17.914 9.41302 18.25 8.99902 18.25C8.58502 18.25 8.24902 17.914 8.24902 17.5V17.197C8.24902 15.733 9.31599 14.25 11.357 14.25H12.641C14.682 14.25 15.749 15.732 15.749 17.197V17.5C15.749 17.914 15.413 18.25 14.999 18.25Z"
      fill={color}
    />
  </svg>
);

export default IconBadge;
